export default "__VITE_ASSET__vdYTeUZG__"